document.addEventListener("DOMContentLoaded", () => {
  const $header = document.querySelector(".js-header");
  if (!$header) return;

  const $stickyContents = document.querySelectorAll(".o-grid__item--sticky");
  const isAdmin = document.body.classList.contains("admin-bar");

  let lastScroll = 0;
  let ticking = false;

  function isMenuOpen() {
    return $header.classList.contains("is-open");
  }

  function onScroll() {
    const scrollY = window.scrollY;
    const scrollingDown = scrollY > lastScroll;

    if (scrollY > 400 && !isMenuOpen()) {
      if (!$header.classList.contains("sticky")) {
        $header.classList.add("sticky");
        setTimeout(() => $header.classList.add("has-transition"), 50);
      }

      if (scrollingDown) {
        $header.classList.add("header-hidden");
        $header.classList.remove("header-visible");
        if (isAdmin) $header.style.top = "0";
        $stickyContents.forEach(el => el.removeAttribute("style"));
      } else {
        $header.classList.remove("header-hidden");
        $header.classList.add("header-visible");
        if (isAdmin) $header.style.top = "50px";
        $stickyContents.forEach(el => (el.style.top = "150px"));
      }

    } else if (scrollY <= 300 && !isMenuOpen()) {
      $header.classList.remove("sticky", "header-hidden", "has-transition");
      if (isAdmin) $header.style.top = "0";
      $stickyContents.forEach(el => el.removeAttribute("style"));
    }

    lastScroll = scrollY;
    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  }

  window.addEventListener("scroll", requestTick);
});
